import { PlaceReservationConfirmation } from 'gleblu-socket-api';

enum ReservationRejectReason {
  Unknown,
  OutsideHours,
}

export default ReservationRejectReason;

export const failureMap = new Map([
  [PlaceReservationConfirmation.outsideHours, ReservationRejectReason.OutsideHours],
  [PlaceReservationConfirmation.failed, ReservationRejectReason.Unknown],
]);
